import { categories, type Category } from '@/mocks/gossip';
import SectionHeading from './SectionHeading';

const toneMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50',
  accent: 'bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50',
  secondary: 'bg-secondary-100 text-secondary-600 group-hover:bg-secondary-600 group-hover:text-background-50',
};

function CategoryCard({ c }: { c: Category }) {
  const iconTone = toneMap[c.tone] ?? toneMap.secondary;
  return (
    <a
      href="#fresh"
      className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200"
    >
      <span
        className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl text-xl transition-colors ${iconTone}`}
      >
        <i className={c.icon} aria-hidden="true"></i>
      </span>
      <div className="min-w-0">
        <h3 className="flex items-center gap-2 text-base font-bold text-foreground-950">
          {c.name}
          <i
            className="ri-arrow-right-up-line text-primary-500 opacity-0 transition-opacity group-hover:opacity-100"
            aria-hidden="true"
          ></i>
        </h3>
        <p className="mt-0.5 truncate text-xs text-foreground-700">{c.desc}</p>
        <span className="mt-1 inline-block rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
          {c.count}
        </span>
      </div>
    </a>
  );
}

export default function Categories() {
  return (
    <section id="cats" className="scroll-mt-24 bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8 py-16 md:py-20">
        <SectionHeading
          eyebrow="瓜圈分类"
          title="按口味挑瓜"
          accentWord="不迷路"
          desc="明星八卦、影视剧综、演出票房、时尚红毯……你的吃瓜口味，这里都能找到同好。"
        />
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {categories.map((c) => (
            <CategoryCard key={c.name} c={c} />
          ))}
        </div>
      </div>
    </section>
  );
}